import { render, staticRenderFns } from "./CommissionOtherTable.vue?vue&type=template&id=4ee2e4af&scoped=true&"
import script from "./CommissionOtherTable.vue?vue&type=script&lang=js&"
export * from "./CommissionOtherTable.vue?vue&type=script&lang=js&"
import style0 from "./CommissionOtherTable.vue?vue&type=style&index=0&id=4ee2e4af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2e4af",
  null
  
)

export default component.exports